import React, { Component } from 'react';
import { Col, message, Row, Select } from 'antd';
import moment from 'moment';
import { queryBudgetGroupPerList } from '@api/finance/budget';
import TableOrg from './TableOrg';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: [],
      condition: moment.unix(new Date().getTime() / 1000).format('YYYY'),
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const params = {};
    const context = this;
    params.year = this.state.condition || '';
    this.setState({
      isLoading: true,
    });
    queryBudgetGroupPerList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          company: this.formatGroup(res.data),
          isLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 递归删除空的children
   */
  formatGroup = arr => {
    arr.map(item => {
      if (item.children) {
        if (item.children.length === 0) {
          delete item.children;
          return item;
        }
        if (item.children.length > 0) {
          this.formatGroup(item.children);
        }
      }
      return item;
    });
    return arr;
  };

  // 根据年份生成表
  setCondition = e => {
    this.setState(
      {
        condition: e,
      },
      () => {
        this.loadData();
      },
    );
  };

  // 设置年份下拉菜单
  yearss = () => {
    const currentYear = moment.unix(new Date().getTime() / 1000).format('YYYY');
    const years = [];
    for (let i = -1; i < 4; i++) {
      years.push(currentYear - i);
    }
    return (
      <Select
        style={{ width: '120px', marginRight: '20px' }}
        placeholder="选择年份"
        onChange={this.setCondition}
        defaultValue={currentYear}
      >
        {years.map(item => (
          <Select.Option key={item}>{item}</Select.Option>
        ))}
      </Select>
    );
  };

  render() {
    const { company, isLoading } = this.state;
    const parentProps = {
      company,
      year: this.state.condition,
      isLoading,
    };

    return (
      <div>
        <Row type="flex" justify="end" style={{ paddingBottom: '20px' }}>
          <Col>{this.yearss()}</Col>
        </Row>
        <TableOrg {...parentProps} company={company} />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/finance/budget/org/Index.js